module.exports = __webpack_public_path__ + "img/protected-cellphone.6222fe0c.svg";